import { render, staticRenderFns } from "./tab-office-firmware.vue?vue&type=template&id=71284cb7&scoped=true"
import script from "./tab-office-firmware.vue?vue&type=script&lang=js"
export * from "./tab-office-firmware.vue?vue&type=script&lang=js"
import style0 from "./tab-office-firmware.vue?vue&type=style&index=0&id=71284cb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71284cb7",
  null
  
)

export default component.exports